import React, { useEffect } from 'react';

import ContentWrapper from 'components/ContentWrapper';
import AccrualReportTable from 'components/tables/AccrualReportTable';
import AccrualReportTableTableHeader from 'components/tables/AccrualReportTable/Header';
import { updateTitle } from 'helpers/common';

const wrapperStyle = {
  padding: '20px 40px 16px 40px',
  display: 'grid',
  gridTemplateColumns: '100%',
  gridTemplateRows: '108px calc(100% - 108px)',
  height: 'calc(100% - 36px)',
  backgroundColor: '#F7F8FA',
};

const AccrualReportScreen: any = ({ ...props }) => {
  const { requestParams } = props;

  useEffect(() => {
    updateTitle('Accrual Report');
  }, []);

  return (
    <ContentWrapper style={wrapperStyle}>
      <AccrualReportTableTableHeader requestParams={requestParams} />
      <AccrualReportTable />
    </ContentWrapper>
  );
};

export default AccrualReportScreen;
